export class FlightSearchModel {
  tripType: string = "One way";
  tripTypeNumber: number = 0;
  origin: string = "Delhi";
  originCode: string = "DEL";
  destinationCode: string = "BOM";
  destination: string = "Mumbai";
  // fromDate: string = new Date().toISOString().split("T")[0]; // Default to today
  fromDate: string = "";
  toDate: string = "";
  travellers: string = "";
  travelClass: string = "Economy";
  preferredAirline: string = "";
  isDirectFlight: boolean = false;
  fareType: string = "";
  customerName: string = "";
  airportName: string = "";
  infants: number = 0;
  currencyCode: string = "INR";
  cabin: number = 0;
  child: number = 0;
  adults: number = 1;
  travellersDetail: string = "1 (Travellers) - Economy";
  status: string = "";

  constructor(data?: Partial<FlightSearchModel>) {
    if (data) {
      Object.assign(this, data); // Merge existing data safely
    }
  }
}
